import { LanguageService } from "./core/services/language.service";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest,
} from "@azure/msal-browser";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  loginStatus: boolean = false;
  lang: string;

  constructor(
    public translate: TranslateService,
    private lang_service: LanguageService,
    private router: Router
  ) {
    translate.addLangs(["en", "it"]);

    this.lang_service.lang.subscribe((lang) => {
      if (lang == "default") {
        translate.setDefaultLang("en");
      } else {
        this.switchLang(lang);
      }
    });
  }

  public switchLang(lang: string) {
    this.translate.use(lang);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationStart))
      .subscribe((data: NavigationStart) => {
        if (data.url === "/id_token") {
          let hash = window.location.hash;
          this.router.navigate(["/"]);
        }
      });
  }
}
